module.exports = "/images/Salesforce.svg?1947ee7204e3247ace3b33762664e62c";